import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import LoginContainer from '../components/authentication/LoginContainer';
import ForgotPasswordContainer from '../components/authentication/ForgotPasswordContainer';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../context/SessionContext';
import { RELEASE_LOGOUT_MESSAGE_KEY } from '../config/release';
import AuthVersionLabel from '../components/authentication/AuthVersionLabel';

const Login: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [releaseMessage, setReleaseMessage] = useState('');
  const navigate = useNavigate();
  const { isLoggedIn, isLoading } = useSession();

  useEffect(() => {
    if (isLoading || !isLoggedIn) return;
    navigate('/', { replace: true });
  }, [isLoading, isLoggedIn, navigate]);

  useEffect(() => {
    const message = sessionStorage.getItem(RELEASE_LOGOUT_MESSAGE_KEY);
    if (!message) return;

    setReleaseMessage(message);
    sessionStorage.removeItem(RELEASE_LOGOUT_MESSAGE_KEY);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '90vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        centered
        textColor="inherit"
        TabIndicatorProps={{ sx: { backgroundColor: '#d32f2f' } }}
      >
        <Tab label="Log In" />
        <Tab label="Forgot your password?" />
      </Tabs>

      {tabValue === 0 ? <LoginContainer /> : <ForgotPasswordContainer />}
      <AuthVersionLabel releaseMessage={releaseMessage} />
    </Box>
  );
};

export default Login;
